// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'upload-image-spinner',
    templateUrl: './upload-image-spinner.component.html',
    styleUrls: ['./upload-image-spinner.component.scss'],
})
export class UploadImageSpinnerComponent implements OnInit {
    getPhrase = ['Uploading Your Image', 'Storing the DDJ Secure Vault', 'Almost Complete…'];

    constructor() {}

    ngOnInit(): void {
        this.changePhrase(this.getPhrase);
    }

    changePhrase(arr) {
        const phrase = document.getElementById('phrase');
        for (let i = 0; i < arr.length; i++) {
            // for each iteration console.log a word
            // and make a pause after it

            (function (i) {
                setTimeout(function () {
                    if (arr[i].length <= 0) {
                        arr = [''];
                    } else {
                        phrase.innerHTML = arr[i];
                    }
                }, 2500 * i);
            })(i);
        }
    }
}
